import viVN from 'antd/lib/locale/vi_VN';

import approveMember from './approveMember';
import auth from './auth';
import calendar from './calendar';
import careers from './careers';
import category from './category';
import certificates from './certificates';
import clubs from './clubs';
import common from './common';
import contacts from './contacts';
import cost from './cost';
import enterprises from './enterprises';
import event from './event';
import feedback from './feedback';
import fields from './fields';
import Form from './form';
import home from './home';
import markets from './markets';
import memberAndPartner from './memberAndPartner';
import memberRank from './memberRank';
import messAlert from './messAlert';
import news from './news';
import notification from './notification';
import organizations from './organizations';
import pageError from './pageError';
import profile from './profile';
import roles from './roles';
import server from './server';
import setting from './setting';
import sponsor from './sponsor';
import targetCustomers from './targetCustomers';
import user from './user';

export default {
  ...viVN,
  ...common,
  ...server,
  ...auth,
  ...pageError,
  ...roles,
  ...user,
  ...sponsor,
  ...cost,
  ...profile,
  ...messAlert,
  ...memberAndPartner,
  ...notification,
  ...calendar,
  ...careers,
  ...certificates,
  ...markets,
  ...targetCustomers,
  ...organizations,
  ...enterprises,
  ...fields,
  ...category,
  ...setting,
  ...clubs,
  ...home,
  ...contacts,
  ...event,
  ...feedback,
  ...news,
  ...memberRank,
  ...approveMember,
  Form,
};
